import request from '@/utils/request'
import config from '@/config'

export default {
  getRoleGroups (params) {
    return request.get(config.ApiYJ + '/account/role_group', { params })
  },
  saveRoleGroup (roleGroup) {
    return request.post(config.ApiYJ + '/account/role_group', roleGroup)
  },
  deleteRoleGroup (id) {
    return request.post(config.ApiYJ + '/account/del_role_group', id)
  },
  getRoles (params) {
    return request.get(config.ApiYJ + '/account/roles', { params })
  },
  saveRole (role) {
    return request.post(config.ApiYJ + '/account/role', role)
  },
  deleteRole (id) {
    return request.post(config.ApiYJ + '/account/del_role', { id: id })
  },
  assignRoles (userId, roleIds) {
    return request.post('/account/assign_role', { userId, roleIds })
  },
  getPermissionGroups (params) {
    return request.get(config.ApiYJ + '/account/permission_group', { params })
  },
  savePermissionGroup (permissionGroup) {
    return request.post(config.ApiYJ + '/account/permission_group', permissionGroup)
  },
  deletePermissionGroup (id) {
    return request.post(config.ApiYJ + '/account/del_permission_group', { id: id })
  },
  getPermissions (params) {
    return request.get(config.ApiYJ + '/account/permission', { params })
  },
  savePermission (permission) {
    return request.post(config.ApiYJ + '/account/permission', permission)
  },
  deletePermission (id) {
    return request.post(config.ApiYJ + '/account/del_permission', { id: id })
  },
  // 用户
  getUsers (params) {
    return request.get(config.ApiYJ + '/account/users', { params })
  },
  saveUser (params) {
    return request.post(config.ApiYJ + '/account/user', params)
  },
  deleteUser (id) {
    return request.post(config.ApiYJ + '/account/deleteUser', { id: id })
  }
}
